<div task-info>
  <div class="inner-task-info !bg-primary-accumin-white flex items-center pl-2 pr-2">
    <div id="scale-bar-position" class="mr-2"></div>
    <div class="mr-1 link-text">
      <a tabindex="0" [outerHTML]="'Module.Menu.Taskbar.TaskInfo.Reference.OSM' | transloco"> &nbsp; </a>
    </div>

    <div class="mr-1 link-text">
      <a tabindex="0" [outerHTML]="'Module.Menu.Taskbar.TaskInfo.Reference.ONGEO' | transloco: { year: currentYear }"> &nbsp; </a>
    </div>

    {{ "Module.Address.Coordinates.Coordinates" | transloco }}: Lon:
    {{ baseMapService.mouseCoordinates?.longitude | translocoDecimal: { minimumFractionDigits: 4, maximumFractionDigits: 4 } }} Lat:
    {{ baseMapService.mouseCoordinates?.latitude | translocoDecimal: { minimumFractionDigits: 4, maximumFractionDigits: 4 } }} ||
    {{ "Module.Menu.Taskbar.TaskInfo.Zoom" | transloco }}:
    {{ baseMapService.getZoomLevel() | translocoDecimal: { minimumFractionDigits: 0, maximumFractionDigits: 0 } }} ||
    {{ "Module.Address.Country" | transloco }}: {{ country?.toUpperCase() }} || {{ "Module.Menu.Taskbar.TaskInfo.Mode" | transloco }}:
    {{ selectedDataModeName() | transloco }}
  </div>
</div>
